import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  ApiPaths,
  APIDataProvider,
  TApiResponse,
  TApiPaginationResponse,
} from '../../api';
import { IAssessQuestion, IQuestion } from '.';

interface IGetAssessQuestions {
  content: string;
  difficulty: string;
}
interface IAIMarking {
  questionId: string;
  marking: string;
}

interface IGetAIMarking {
  questionId: string;
  answer?: string;
}

interface IGetQuestionsByCurriculumSubject {
  limit: number;
  offset: number;
  curriculum?: string;
  subject?: string;
  topic?: string;
  subTopic?: string;
  difficulty?: string[];
}

const apiDataProvider = new APIDataProvider();

export const getQuestionsBySubTopic = createAsyncThunk(
  'questions/subTopic',
  async (subTopic: string) => {
    const response = await apiDataProvider.get<TApiResponse<IQuestion[]>>(
      `${ApiPaths.questions}/subtopics/${subTopic}`
    );

    return response.data;
  }
);

export const getRandomQuestionsBySubTopic = createAsyncThunk(
  'questions/random/subTopic',
  async (subTopic: string) => {
    const response = await apiDataProvider.get<TApiResponse<IQuestion[]>>(
      `${ApiPaths.questions}/subtopic/random/${subTopic}`
    );

    return response.data;
  }
);

export const getAssessQuestions = createAsyncThunk(
  'questions/assess-questions',
  async (data: IGetAssessQuestions) => {
    const path = `${ApiPaths.questions}/assess-questions?content=${data.content}&difficulty=${data.difficulty}`;

    const response = await apiDataProvider.get<TApiResponse<IAssessQuestion[]>>(
      path
    );

    return response.data;
  }
);

export const getAIMarking = createAsyncThunk(
  'questions/ai-marking',
  async (data: IGetAIMarking) => {
    const path = `${ApiPaths.questions}/ai-marking?questionId=${data.questionId}&answer=${data.answer}`;

    const response = await apiDataProvider.get<TApiResponse<IAIMarking>>(path);

    return response.data;
  }
);

export const getQuestionsByCurriculumSubject = createAsyncThunk(
  'questions/curriculumSubject',
  async (data: IGetQuestionsByCurriculumSubject) => {
    const params = new URLSearchParams({
      limit: data.limit.toString(),
      offset: data.offset.toString(),
    });

    if (data.curriculum) {
      params.append('curriculum', data.curriculum);
    }
    if (data.subject) {
      params.append('subject', data.subject);
    }
    if (data.topic) {
      params.append('topic', data.topic);
    }
    if (data.subTopic) {
      params.append('subTopic', data.subTopic);
    }
    if (data.difficulty) {
      params.append('difficulty', data.difficulty.join(','));
    }

    const response = await apiDataProvider.get<
      TApiResponse<TApiPaginationResponse<IQuestion>>
    >(`${ApiPaths.questions}/curriculum-subject?${params.toString()}`);

    return response.data;
  }
);
